import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import styles from '../RemoteOralExam.scss';
import ZoomFrame from './ZoomFrame';
import zoomWrapperSelector from '../../../selectors/remoteOralExam/zoomIntegration/ZoomWrapperSelector';

const ZoomWrapper = ({ frameSrc, isMenuPage, isTopicVisible }) => {
    let wrapperClassName = styles.absolutePlaceholder;

    if (isMenuPage) {
        wrapperClassName += ` ${styles.hidden}`;
    } else if (isTopicVisible) {
        wrapperClassName += ` ${styles.splitScreen}`;
    }

    return (<div className={wrapperClassName}>
        { (isMenuPage || isTopicVisible) &&
            <div className={styles.topicPlaceholder} />
        }
        <div className={styles.videoContainer}>
            <div className={styles.videoWrapper}>
                <div className={styles.videoPlaceholder}>
                    <ZoomFrame frameSrc={frameSrc} />
                </div>
            </div>
        </div>
    </div>);
};

ZoomWrapper.propTypes = {
    frameSrc: PropTypes.string,
    isMenuPage: PropTypes.bool.isRequired,
    isTopicVisible: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return zoomWrapperSelector.mapStateToProps(state);
};

export default connect(mapStateToProps)(ZoomWrapper);
